export const purchaseOrderStockUnits = [
  { value: 'sacks', label: 'Sacks' },
  { value: 'kg', label: 'Kilograms (kg)' },
];

export const purchaseOrderStatuses = [
  { value: 'Initial', label: 'Initial' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Received', label: 'Received' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export function createPurchaseOrderFormInitialValues() {
  return {
    poDate: getTodayDateInputValue(),
    supplierId: '',
    quantity: '',
    price: '',
    warehouseLocation: '',
    actualPrice: '',
    receivedQuantity: '',
    stockUnit: 'sacks',
    lansaName: '',
    sacksMark: '',
    deliveryDate: '',
    seaweedType: '',
    status: 'Initial',
    balancingReadyAt: '',
  };
}

export const purchaseOrderFormInitialValues = createPurchaseOrderFormInitialValues();

function getTodayDateInputValue() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
